import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/content`);
        setContent(data);
      } catch (e) {
        console.error("content load failed", e);
        setContent({});
      }
    })();
  }, []);

  return (
    <ContentContext.Provider value={content}>{children}</ContentContext.Provider>
  );
}

export function useContent(section) {
  const ctx = useContext(ContentContext);
  if (!ctx) return null;
  return section ? ctx[section] || null : ctx;
}
